import WestonHeroSection from "./components/HeroSection";
import WestonStickyNav from "./components/StickyNav";
import WestonProcessingTimeSection from "./components/ProcessingTimeSection";
import WestonServicesSection from "./components/ServicesSection";
import WestonLocalAreaSection from "./components/LocalAreaSection";
import WestonTravelTimingSection from "./components/TravelTimingSection";
import WestonDestinationsSection from "./components/DestinationsSection";
import WestonTestimonialsSection from "./components/TestimonialsSection";
import WestonAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WestonComparisonSection from "./components/ComparisonSection";
import WestonMistakesSection from "./components/MistakesSection";
import WestonHowItWorksSection from "./components/HowItWorksSection";
import WestonFAQSection, { faqs } from "./components/FAQSection";
import WestonHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WestonFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function WestonPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Weston"
        state="Florida"
        stateAbbr="FL"
        route="/weston"
        title="Emergency Passport Weston, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Weston, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Broward County travelers."
        geoPlacename="Weston, Florida"
        geoPosition="26.1004;-80.3998"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
      />
      <WestonHeroSection />
      <WestonStickyNav />
      <WestonProcessingTimeSection />
      <WestonServicesSection />
      <WestonLocalAreaSection />
      <WestonTravelTimingSection />
      <WestonDestinationsSection />
      <WestonTestimonialsSection />
      <WestonAcceptanceFacilitiesSection />
      <WestonComparisonSection />
      <WestonMistakesSection />
      <WestonHowItWorksSection />
      <WestonFAQSection />
      <WestonHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/weston" state="FL" />
      <WestonFinalCTA />
    </div>
  );
}